const NeedToImplement = (props) => {
  return <h1 style={{ color: "red" }}>Need to Implement {props.name}</h1>
}

export default NeedToImplement
